export default {
  background: {
    toNight: 'Switch to night mode',
    toDay: 'Switch to day mode'
  },
  colorPicker: 'Select background color',
  zoom: {
    in: 'Zoom in',
    out: 'Zoom out'
  },
  layers: 'Manage layers',
  legend: {
    show: 'Show legend',
    hide: 'Hide legend'
  },
  coordinates: 'View coordinates',
  mapControls: {
    show: 'Show map controls',
    hide: 'Hide map controls'
  },
  download: 'Download map snapshot'
}
